import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'

export const storagePersister = createSyncStoragePersister({
  storage: window.localStorage,
})
